var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _g4, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBestFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 190,
    viewBox: "0 0 375 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_2647)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_252_2647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: -9,
    width: 408,
    height: 205
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7.93555 195.095H399.15V-8.83691H-7.93555V195.095Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_252_2647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.869 104.729C219.869 107.782 219.253 110.476 218.025 112.813C216.794 115.153 215.141 117.079 213.064 118.591C210.607 120.405 207.974 121.691 205.165 122.447C202.355 123.204 198.729 123.582 194.283 123.582H175.542V62.1943H192.872C197.523 62.1943 201.011 62.338 203.337 62.6277C205.661 62.915 207.893 63.595 210.027 64.6651C212.367 65.8446 214.078 67.3901 215.16 69.3003C216.242 71.2093 216.785 73.4539 216.785 76.0339C216.785 78.9203 215.972 81.4979 214.35 83.778C212.725 86.0581 210.476 87.8438 207.612 89.1326V89.4631C211.507 90.4519 214.523 92.2617 216.66 94.8888C218.801 97.5172 219.869 100.794 219.869 104.729ZM207.741 77.1816C207.741 75.6984 207.476 74.4122 206.951 73.3281C206.425 72.2414 205.576 71.3822 204.405 70.7505C203.002 70.0083 201.436 69.5545 199.71 69.3906C197.985 69.2241 195.598 69.1427 192.556 69.1427H184.22V87.1168H194.092C196.815 87.1168 198.82 86.9859 200.107 86.7241C201.394 86.4623 202.723 85.9209 204.098 85.0947C205.417 84.2991 206.352 83.2543 206.907 81.9643C207.462 80.673 207.741 79.0767 207.741 77.1816ZM210.826 105.067C210.826 102.75 210.474 100.843 209.772 99.341C209.068 97.84 207.65 96.5653 205.514 95.5193C204.136 94.833 202.636 94.3919 201.013 94.1974C199.388 94.0055 197.083 93.9077 194.097 93.9077H184.22V116.634H191.288C195.092 116.634 198.091 116.467 200.287 116.14C202.483 115.809 204.414 115.105 206.083 114.033C207.724 112.956 208.923 111.738 209.684 110.376C210.445 109.011 210.826 107.24 210.826 105.067Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.516 123.584V62.1943H269.445V69.458H237.192V86.2805H267.249V93.5428H237.192V116.321H269.445V123.584H228.516Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_252_2647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: -9,
    width: 408,
    height: 205
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.93555 195.095H399.15V-8.83691H-7.93555V195.095Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_252_2647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.151 124.679C292.415 124.679 288.387 124.22 285.068 123.3C281.748 122.383 278.629 121.248 275.706 119.903V109.686H276.319C279.183 112.21 282.428 114.162 286.053 115.551C289.677 116.935 293.171 117.627 296.533 117.627C301.326 117.627 304.954 116.687 307.409 114.805C309.864 112.924 311.092 110.446 311.092 107.371C311.092 104.925 310.446 102.934 309.162 101.396C307.878 99.8572 305.829 98.7184 303.025 97.9774C301.007 97.4296 299.164 96.9759 297.496 96.6175C295.828 96.2629 293.74 95.7799 291.222 95.1762C288.973 94.6272 286.953 93.9281 285.168 93.074C283.385 92.2225 281.804 91.1104 280.429 89.7377C279.086 88.3892 278.039 86.8056 277.295 84.9754C276.547 83.1516 276.174 81.043 276.174 78.6498C276.174 73.679 278.236 69.5102 282.359 66.1459C286.48 62.7817 291.741 61.0977 298.146 61.0977C301.802 61.0977 305.257 61.4395 308.518 62.1271C311.779 62.8173 314.795 63.7921 317.574 65.0567V74.8393H316.918C314.841 73.0485 312.179 71.4865 308.937 70.152C305.692 68.8188 302.287 68.1502 298.721 68.1502C294.689 68.1502 291.427 69.0348 288.945 70.8078C286.46 72.577 285.218 74.9055 285.218 77.7893C285.218 80.3986 285.949 82.4716 287.409 84.0094C288.87 85.5486 290.989 86.6759 293.768 87.3864C295.609 87.8528 297.861 88.3829 300.521 88.9726C303.186 89.5649 305.394 90.1063 307.149 90.6007C311.65 91.892 314.944 93.8442 317.019 96.4522C319.094 99.0641 320.133 102.276 320.133 106.095C320.133 108.485 319.615 110.847 318.575 113.183C317.538 115.516 316.082 117.496 314.212 119.115C312.107 120.901 309.733 122.278 307.088 123.235C304.44 124.201 301.126 124.679 297.151 124.679Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M344.287 123.584V69.458H322.334V62.1943H374.915V69.458H352.962V123.584H344.287Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_252_2647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: -9,
    width: 408,
    height: 205
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.93555 195.095H399.15V-8.83691H-7.93555V195.095Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_252_2647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.936 123.664L128.542 115.372H90.9568L76.5667 123.664C90.3357 147.577 131.507 186.737 176.119 190.126C160.573 181.424 135.835 150.152 142.936 123.664Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_252_2647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: -9,
    width: 408,
    height: 205
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.93555 195.095H399.15V-8.83691H-7.93555V195.095Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_252_2647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.936 123.664L128.542 115.372H90.9568L76.5667 123.664C90.3357 147.577 131.507 186.737 176.119 190.126C160.573 181.424 135.835 150.152 142.936 123.664Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.096 0.177246C153.329 17.9887 138.611 55.0273 112.11 62.1295L112.119 78.7335L130.91 111.272L145.292 119.584C159.127 95.7048 172.473 40.49 153.096 0.177246Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.394 62.1295C79.7921 62.0913 25.2716 78.1539 0.0369873 115.082C15.3516 105.973 54.8111 100.189 74.2105 119.589L88.5891 111.272L107.383 78.7386L107.394 62.1295Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.939 101.789C100.939 96.9288 104.885 92.9888 109.752 92.9888C114.616 92.9888 118.558 96.9288 118.558 101.789C118.558 106.666 114.616 110.594 109.752 110.594C104.885 110.594 100.939 106.666 100.939 101.789Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M335.304 141.427H328.435V129.662H330.011V140.037H335.304V141.427ZM345.144 129.662L341.068 141.427H339.365L335.289 129.662H336.977L340.256 139.428L343.536 129.662H345.144ZM350.422 141.427H345.821V140.226H347.333V130.863H345.821V129.662H350.422V130.863H348.91V140.226H350.422V141.427ZM360.954 129.662L356.878 141.427H355.174L351.098 129.662H352.786L356.066 139.428L359.346 129.662H360.954Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_2647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 190,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBestFooter);
export default __webpack_public_path__ + "static/media/logo_best_footer.1477f3e00a6b450efeab00fedaa78007.svg";
export { ForwardRef as ReactComponent };